import React from 'react';
import {Route} from 'react-router-dom';
import AsyncList from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
export default (
  <Route key="/business/video/detail" element={<DefaultBusinessLayout />}>
    <Route path="business/video/:videoId" element={<AsyncList />} />
  </Route>
);
